module.exports = "/images/banos.jpg?e971c74011716ce850f0cb0f2c8daeb5";